<template>
  <dsf-exam-layout :exam-loading="examLoading">
    <template #header>
      <el-row type="flex" justify="space-around">
        <el-col :span="8">
          <el-tooltip v-if="examInfoData.manageName" effect="light" :content="examInfoData.manageName" placement="right">
            <h3 class="name">{{ examInfoData.manageName || examInfoData.name }}</h3>
          </el-tooltip>
          <el-tooltip v-if="examInfoData.name" effect="light" :content="examInfoData.name" placement="right">
            <h3 class="name">{{ examInfoData.manageName || examInfoData.name }}</h3>
          </el-tooltip>
        </el-col>
        <el-col :span="8">
          <h3 class="time"></h3>
        </el-col>
        <el-col :span="8">
          <div class="user">{{ examInfoData.examUserName }}</div>
        </el-col>
      </el-row>
    </template>
    <template #left>
      <p class="sub-title list bg pd-10">答题卡</p>
      <div class="card-list">
        <el-row class="card-tips pd-10" v-if="!previewStatus">
          <el-col :span="8" class="a1">已答：{{ answeredCount }}</el-col>
          <el-col :span="8" class="a2">未答：{{ speedLength - answeredCount }}</el-col>
          <el-col :span="8" class="a3">标记：{{ markedCount }}</el-col>
        </el-row>
        <el-row class="card-tips pd-10" v-else>
          <el-col :span="8" class="a1">正确：{{ examInfoData.corretNum }}</el-col>
          <el-col :span="8" class="error">错误：{{ speedLength - examInfoData.corretNum }}</el-col>
          <!-- <el-col :span="8" class="a2">未答：{{ speedLength - answeredCount }}</el-col> -->
        </el-row>
        <template v-for="data in examInfoData.items">
          <p class="sub-title list pd-10" :key="data.examPaperItemsId">
            {{ data.name }}<span class="sub">（共{{ data.totalNum }}题，合计{{ data.totalScore }}分）</span>
          </p>
          <div class="question-list" :key="data.examPaperId + data.examPaperItemsId">
            <template v-for="(q, i) in data.questions">
              <div
                v-if="data.questionsItems.value != 'group'"
                :class="['item', q.handleResults, q.answered ? 'answered' : '', q.marked ? 'marked' : '']"
                :key="q.examPaperId"
                @click="toScroll(q.examQuestionsId)"
              >
                {{ ++i }}
              </div>
              <template v-for="childValue in q.children" v-else>
                <div
                  :class="['item', childValue.handleResults, childValue.answered ? 'answered' : '', childValue.marked ? 'marked' : '']"
                  :key="childValue.examPaperId"
                  @click="toScroll(childValue.examQuestionsId, childValue.groupIndex - 1)"
                >
                  {{ childValue.groupIndex }}
                </div>
              </template>
            </template>
          </div>
        </template>
      </div>
    </template>
    <template #main>
      <template v-for="(data, index) in examInfoData.items">
        <p class="sub-title list bg pd-20" :key="data.examPaperItemsId">
          {{ dsf.math.toChinesNum(++index) + "、" + data.name }}
          <template v-if="(data.questionsItems.value == 'subjective' && data.totalScore) || (data.score && data.totalScore)">
            <span class="sub"> （共{{ data.questions.length }}题，合计{{ data.totalScore }}分） </span>
          </template>
        </p>
        <div class="exam-content" :key="data.examPaperItemsId + index">
          <div v-for="(subjects, examIndex) in data.questions" :ref="'question' + subjects.examQuestionsId" :key="subjects.examQuestionsId">
            <dsf-exam-item-box
              :hide-mark="true"
              :show-score="showScore"
              :previewStatus="previewStatus"
              :readOnly="isReadOnly"
              :subjects="subjects"
              :exam-index="examIndex"
            />
          </div>
        </div>
      </template>
    </template>
    <!-- z-index: 0  -->
    <template #right>
      <div class="timer">
        <p class="txt">作答时间</p>
        <p class="result-time">
          {{ getTime.hours + ":" + getTime.minutes + ":" + getTime.seconds }}
        </p>
      </div>
      <div class="current-progress">
        <p class="txt">作答进度</p>
        <el-progress :percentage="percentageNumber" :format="format"></el-progress>
      </div>
      <div class="timer">
        <p class="txt">考试成绩</p>
        <p class="result-time">
          {{ $route.query.type == "preview" ? "- -" : examInfoData.showText }}
        </p>
      </div>
      <div class="current-progress">
        <p class="txt">考试总分</p>
        <p class="aside-text">{{ examInfoData.totalScore }} 分</p>
      </div>
      <dsf-setting-font-size />
    </template>
  </dsf-exam-layout>
</template>

<script>
export default {
  name: "DsfExamRecord",
  provide() {
    return {
      exam: this,
    };
  },
  data() {
    return {
      examLoading: false,
      isReadOnly: true, // 是否只读
      getTime: {
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00",
      },
      // 请求获取的数据
      examInfoData: {},

      // 考试进度 speed
      speedLength: 0,
      allStatus: [],
      form: [],
      answeredCount: 0,
      markedCount: 0,
      previewStatus: false,
      percentageNumber: 0,
      showScore: false,
    };
  },
  created() {
    // 获取信息
    this.queryData();
  },
  mounted() {
    window.onbeforeunload = function (e) {};
  },
  methods: {
    queryData() {
      this.examLoading = true;
      this.$http
        .get("/manage/getPaperByType?id=" + this.$route.query.id + "&type=" + this.$route.query.type, {}, $$webRoot.exam)
        .done((res) => {
          if (res.success) {
            this.examLoading = false;
            this.examInfoData = res.data;
            this.getTime = dsf.date.secondsToTime(res.data.useTime);
            // 给多个组合题一个叠加索引 计算总题数
            let groupLen = 0;
            _.forEach(this.examInfoData.items, (item) => {
              // if (item.questionsItems.value == "group") {
              let groupIndex = 0;
              _.forEach(item.questions, (questions) => {
                if (item.questionsItems.value == "group") {
                  _.forEach(questions.children, (child) => {
                    child.groupIndex = ++groupIndex;
                    // 设置默认表单错误状态
                    if (res.data.published) {
                      child.handleResults = child.handleResults === "right" ? "right" : "error";
                    }
                    this.$nextTick(() => {
                      if (child.items.value == "input") {
                        child.answered = child.answered || child.fontNum == child.result?.length;
                        this.answeredCount += child.fontNum == child.result?.length ? 1 : 0;
                      } else {
                        this.answeredCount += child.answered ? 1 : 0;
                      }
                    });
                  });
                } else {
                  if (res.data.published) {
                    questions.handleResults = questions.handleResults === "right" ? "right" : "error";
                  }
                  this.$nextTick(() => {
                    if (questions.items.value == "input") {
                      questions.answered = questions.answered || questions.fontNum == questions.result?.length;
                      this.answeredCount += questions.fontNum == questions.result?.length ? 1 : 0;
                    } else {
                      this.answeredCount += questions.answered ? 1 : 0;
                    }
                  });
                }
              });
              this.speedLength += groupIndex;
              if (item.questionsItems.value !== "group") {
                groupLen += Number(item.questions.length);
              }
            });

            this.$nextTick(() => {
              this.speedLength += groupLen;
              this.percentageNumber = this.answeredCount * (10 / this.speedLength) * 10;
            });
            this.showScore = res.data.showScore; //false 不显示
            this.previewStatus =
              res.data.published && this.$route?.query?.type != "preview" && this.$route?.query?.type != "manage" && res.data.showAnswer
                ? true
                : false;
          } else {
            dsf.layer.message(res.message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message, false);
        });
    },
    toScroll(examId, childKey) {
      const scrollTop = document.querySelectorAll(".ds-virtual-scroll-box")[1].scrollTop;
      let top = 0;
      if (childKey >= 0) {
        top = document.querySelectorAll("[child-refs]")[childKey].getBoundingClientRect().top;
      } else {
        top = this.$refs["question" + examId][0].getBoundingClientRect().top;
      }
      document.querySelectorAll(".ds-virtual-scroll-box")[1].scrollTo({
        top: top + scrollTop - 60, // 110
        behavior: "smooth", // 平滑滚动
      });
    },
    format() {
      return this.answeredCount + "/" + this.speedLength;
    },
  },
};
</script>
